import {
  APP_INITIALIZER,
  enableProdMode,
  ErrorHandler,
  importProvidersFrom,
  isDevMode,
} from '@angular/core';
import * as Sentry from '@sentry/angular';

import { provideHttpClient, withFetch } from '@angular/common/http';
import {
  getAnalytics,
  provideAnalytics,
  ScreenTrackingService,
  UserTrackingService,
} from '@angular/fire/analytics';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, Router } from '@angular/router';
import { provideClarity } from '@shared/clarity';

import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from 'libs/shared/src/lib/environments/environment';
import { provideNgxMask } from 'ngx-mask';
import { WsService } from '../../../chat/src/app/services/ws.service';
import { routes } from './app.routes';

Sentry.init({
  dsn: 'https://9ea8f1b2080c47a29e38759dc915f735@o548650.ingest.sentry.io/6385929',
  environment: environment.production ? 'production' : 'development',
  tracesSampleRate: 0.1,
  integrations: [Sentry.browserTracingIntegration()],
});

if (environment.production) {
  enableProdMode();
}

export const appConfig = {
  providers: [
    provideRouter(routes),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAnalytics(() => getAnalytics()),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideFunctions(() => getFunctions()),
    ScreenTrackingService,
    UserTrackingService,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    WsService,
    provideNgxMask(),
    provideHttpClient(withFetch()),
    provideClarity({
      enabled: true,
      projectId: environment.clarityId,
    }),
    provideAnimations(),
    importProvidersFrom([
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: !isDevMode(),
        // Register the ServiceWorker as soon as the application is stable
        // or after 30 seconds (whichever comes first).
        registrationStrategy: 'registerWhenStable:30000',
      }),
    ]),
  ],
};
